module.exports = __webpack_public_path__ + "img/mobile_map_jaboatao.65463908.svg";